import { useDispatch, useSelector } from "react-redux";
import React, { FC, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";

import Top from "../../ScreenAuth/Top/Top";
import Helmet1 from "../../modules/Loading/Helmet1";
import PreLoadingView from "../../modules/Loading/PreLoadingView";
import { post_variable } from "stores/API/actions";

function Route() {
  const dispatch = useDispatch();
  useEffect(() => {
    setTimeout(() => {
      dispatch(post_variable({ Top: true }));
    }, 2000);
  }, []);
  const reduce_variable = useSelector((state) => state.reduce_variable);

  return (
    <>
      {reduce_variable.Top ? (
        <>
          <Top />
        </>
      ) : (
        <PreLoadingView />
      )}

      <Helmet1 />
      <Helmet>
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1.0,minimum-scale=1.0"
        />
        <meta name="apple-mobile-web-app-capable" content="yes" />
        <title>SC WORLD EXCHANGE</title>
        <link
          id="Top"
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v5.7.0/css/all.css"
          integrity="sha384-lZN37f5QGtY3VHgisS14W3ExzMWZxybE1SJSEsQp9S+oqd12jhcu+A56Ebc1zFSJ"
          crossorigin="anonymous"
        />
        <link
          rel="stylesheet"
          href="https://cdn.datatables.net/1.10.19/css/jquery.dataTables.min.css"
        />
        <link
          id="Top"
          rel="stylesheet"
          href="/dist/css/front.css"
          onload="$('.Helmet1').hide()"
        />
      </Helmet>
      {/* {width > 992 ? ( */} {/* ) : ( */}
      {/* <div id="style-sm" className="overflow-hidden"> */} {/* <Router /> */}
      {/* </div> */} {/* )} */}
      {/* <div className="d-none d-lg-block">
                    <About />
                  </div>
                  <div className="d-lg-none overflow-hidden"><AboutSm /></div> */}
    </>
  );
}

export default Route;
